import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const AboutPage = () => {
  const { aboutApi } = apiPath;
  const [about, aboutLoading] = useFetch(aboutApi);

  if (aboutLoading) {
    return <Loading />;
  }
  const {
    aboutBannerImage,
    aboutBannerImageMini,
    countriesWeWork,
    mission,
    positiveFeedback,
    successfulProject,
    vision,
    weAchievedDescription,
    weAchievedTitle,
    yearsOfExp,
    pageTitle,
    _id,
  } = about;

  // const aboutPointListData = [];
  // aboutPointList?.map((item, index) => {
  //   aboutPointListData.push({
  //     label: `About Points ${index}`,
  //     type: "text",
  //     name: "",
  //     defaultValue: item,
  //   });
  // });

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "aboutBannerImage",
      defaultValue: aboutBannerImage,
      required: false,
    },
    {
      elementType: "textField",
      label: "Banner Title",
      type: "Text",
      name: "pageTitle",
      defaultValue: pageTitle,
      required: false,
    },
    {
      elementType: "input",
      label: "What we achieved title",
      type: "Text",
      name: "weAchievedTitle",
      defaultValue: weAchievedTitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "What we achieved description",
      type: "Text",
      name: "weAchievedDescription",
      defaultValue: weAchievedDescription,
      required: false,
    },
    {
      elementType: "input",
      label: "Countries we work",
      type: "Text",
      name: "countriesWeWork",
      defaultValue: countriesWeWork,
      required: true,
    },
    {
      elementType: "input",
      label: "Successful project",
      type: "Text",
      name: "successfulProject",
      defaultValue: successfulProject,
      required: false,
    },
    {
      elementType: "input",
      label: "Positive feedback",
      type: "Text",
      name: "positiveFeedback",
      defaultValue: positiveFeedback,
      required: false,
    },
    {
      elementType: "input",
      label: "Years Of exp",
      type: "Text",
      name: "yearsOfExp",
      defaultValue: yearsOfExp,
      required: false,
    },

    {
      elementType: "textField",
      label: "Mission",
      type: "Text",
      name: "mission",
      defaultValue: mission,
      required: true,
    },
    {
      elementType: "textField",
      label: "Vision",
      type: "Text",
      name: "vision",
      defaultValue: vision,
      required: false,
    },
    {
      elementType: "file",
      label: "Mission Vision Banner Image",
      type: "file",
      name: "aboutBannerImageMini",
      defaultValue: aboutBannerImageMini,
      required: false,
    },
  ];

  const nestedData = [
    // {
    //   elementType: "input",
    //   label: "years Of Exp",
    //   name: "yearsOfExp",
    //   multipleData: yearsOfExp,
    //   multiple: true,
    //   required: false,
    // },
  ];

  const useData = data.concat(nestedData);

  const update = (data) => {
    console.log(data);
    updateData(`${aboutApi}/${_id}`, data, true);
  };

  return (
    <div>
      <GlobalForm data={useData} nestedData={nestedData} update={update} />
    </div>
  );
};

export default AboutPage;
